<template>
  <div class="py-10 lg:py-20" :class="model.background">
    <div class="mx-auto w-full max-w-screen-xl px-5 md:px-12">
      <div class="home-categories">
        <div class="info">
          <div class="max-w-[400px]">
            <div class="mb-7 text-2xl font-bold lg:text-5xl">{{ model.title }}</div>
            <div class="text-lg">{{ model.subtitle }}</div>
            <div v-if="model.buttons && model.buttons.length" class="mt-6 flex space-x-6 lg:mt-9">
              <VcButton
                v-for="(item, index) in model.buttons"
                :key="index"
                size="lg"
                v-bind="getLinkAttr(item.link)"
                class="w-auto px-8"
              >
                {{ item.label }}
              </VcButton>
            </div>
          </div>
        </div>
        <div class="category category1">
          <a :href="model.link01">
            <img class="lg:min-h-[500px]" :src="model.image01" alt="" />
            <span class="category-title">{{ model.category01 }}</span>
          </a>
        </div>
        <div class="category category2">
          <a :href="model.link02">
            <img :src="model.image02" alt="" />
            <span class="category-title">{{ model.category02 }}</span>
          </a>
        </div>
        <div class="category category3">
          <a :href="model.link03">
            <img :src="model.image03" alt="" />
            <span class="category-title">{{ model.category03 }}</span>
          </a>
        </div>
        <div class="category category4">
          <a :href="model.link04">
            <img :src="model.image04" alt="" />
            <span class="category-title">{{ model.category04 }}</span>
          </a>
        </div>
        <div class="category category5">
          <a :href="model.link05">
            <img :src="model.image05" alt="" />
            <span class="category-title">{{ model.category05 }}</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { getLinkAttr } from "@/core/utilities/common";

defineProps({
  model: {
    type: Object,
    required: true,
  },

  settings: {
    type: Object,
    required: true,
  },
});
</script>

<style scoped>
.home-categories {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-column-gap: 2rem;
  grid-row-gap: 2rem;
}

.info {
  grid-area: 1 / 1 / 3 / 3;
}
.category1 {
  grid-area: 1 / 3 / 3 / 4;
}
.category2 {
  grid-area: 1 / 4 / 2 / 5;
}
.category3 {
  grid-area: 2 / 4 / 3 / 5;
}
.category4 {
  grid-area: 3 / 1 / 4 / 4;
  max-height: 300px;
}
.category5 {
  grid-area: 3 / 4 / 4 / 5;
}

.category {
  position: relative;
}

.category-title {
  position: absolute;
  top: 1.25rem;
  left: 2rem;
  border: 1px solid var(--color-white);
  background: rgba(0, 0, 0, 0.15);
  border-radius: 0.625rem;
  padding: 0.2rem 0.5rem;
  color: var(--color-white);
  font-size: 1.1rem;
  line-height: 1.2;
}

.home-categories img {
  display: block;
  width: 100%;
  height: 100%;
  border-radius: 2rem;
  object-fit: cover;
}

@media (max-width: 768px) {
  .home-categories {
    grid-template-columns: repeat(4, 1fr);
    grid-column-gap: 0.9rem;
    grid-row-gap: 0.9rem;
  }

  .info {
    grid-area: 1 / 1 / 2 / 5;
  }
  .category1 {
    grid-area: 2 / 1 / 4 / 2;
  }
  .category2 {
    grid-area: 2 / 2 / 3 / 3;
  }
  .category3 {
    grid-area: 2 / 3 / 3 / 4;
  }
  .category4 {
    grid-area: 3 / 2 / 4 / 5;
  }
  .category5 {
    grid-area: 2 / 4 / 3 / 5;
  }

  .category-title {
    left: 0.5rem;
    top: 0.5rem;
    font-size: 0.625rem;
    line-height: 1.2;
  }

  .home-categories img {
    border-radius: 0.625rem;
  }
}

@media (max-width: 450px) {
  .category-title {
    display: none;
  }
}
</style>
